module.exports = __webpack_public_path__ + "static/media/table-s.50970c9b.png";